
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import BottomNav from '../../components/bottomnav/BottomNav.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getCommentaire, getClient, getResa } from "../../store/selectors.js";
import { resaSlice } from "../../store/resaSlice.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Utils 
import setNumResa from '../../utils/set_num_resa.js';



//MUI :
import Button from '@mui/material/Button';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CheckIcon from '@mui/icons-material/Check';
import Alert from '@mui/material/Alert';

function EditValidate() { // full page as component imported in router

    let selectedCreneaux = useSelector(getSelectedCreneaux);
    let formulesEleves = useSelector(getFormulesEleves);
    let theClient = useSelector(getClient);
    let elevesList = useSelector(getEleves);
    let formulesList = useSelector(getFormules);
    let comment = useSelector(getCommentaire);
    let resaInfos = useSelector(getResa);

    let problemes = []; //list to store problems in requests
    let totalResa = 0; //amount of the current resa
    let currentClient = 0; //id of current client
    let currentResa = 0; // id of current resa (got from response)
    let idChanges = []; // list to store the switch of new eleve ids (from -1 to 345 for eg)

    const navigate = useNavigate();
    const dispatch = useDispatch();

    let alertBaseMessage = "Oups, une erreur est parvenue pendant l'enregistrement de votre demande. \n Vous pouvez réessayer à nouveau.\n Code erreur :";
    let [alertMessage, setAlertMessage] = useState("");
    let [showAlert, setShowAlert] = useState(false);



    // 

    function modifResa() {


        axios.put(`${baseURL}/resa/${resaInfos.id_resa}`, { //fetch create resa
            nb_modifs: resaInfos.nb_modifs + 1,
            match: false,
            coupon: resaInfos.coupon,
            total: resaInfos.total,
            solde: resaInfos.solde
        })
            .then((response) => {
                if (response.status === 200) { // everything went good..
                    // appeler fonction insert Resa/creneau
                    insertResaCreneaux();
                }
                else { // if probleme...
                    problemes.push(response.data); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "resa-put" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {
                //console.error(error);
                problemes.push(error); //add probleme to list
                // ----- error management
                setAlertMessage(alertBaseMessage + "resa-put" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })

    }



    // faire une boucle pour remplir la table de jointure Resa/creneau

    function insertResaCreneaux() { //first, we delete existing, and then insert again
        //console.log(idResa)
        let idResa = resaInfos.id_resa
        currentResa = idResa; // get resa id from previous fetch response
        let nbSuccess = 0; // to count the number of succesfull fetch


        // Clear all existing creneaux for this resa ...
        axios.delete(`${baseURL}/resa-creneau/${idResa}`)
            .then((response) => {
                if (response.status === 201) { // if request ok
                    console.log("anciens créneaux supprimés")
                    reFill(true);
                }
                else { //
                    problemes.push(response.data);
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "ResaCreneau-delete" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {

                problemes.push(error);
                // ----- error management
                setAlertMessage(alertBaseMessage + "ResaCreneau-delete" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })

        function reFill(flag) { //function inside insertCreneaux
            console.log(flag)
            //// ...and refill again
            selectedCreneaux.map((creneau) => { // we map all the selected creneaux

                axios.post(`${baseURL}/resa-creneau`, { //we fill the ResaCreneau db table...
                    creneau_id: creneau.creneau.id_creneau,  //...with creneau id
                    resa_id: idResa                            //...and resa id
                })
                    .then((response) => {
                        if (response.status === 201) { // if request ok
                            nbSuccess++;  // ...we increment compteur
                            if (nbSuccess === selectedCreneaux.length) { // if nbsuccess = number of selected creneaux...
                                console.log(nbSuccess);
                                insertCreneauxEleves(); //... we go to next step, insert Creneau eleves
                            }

                        }
                        else { //
                            problemes.push(response.data);
                            // ----- error management
                            setAlertMessage(alertBaseMessage + "ResaCreneau-post" + response.status);
                            setShowAlert(true);
                            return;
                            // ---------------
                        }
                    })
                    .catch(error => {

                        problemes.push(error);
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "ResaCreneau-post" + error.message);
                        setShowAlert(true);
                        return;
                        // ---------------
                    })
            });// end of map
        }
    }



    function insertCreneauxEleves() {

        problemes.length = 0; // reset array to empty
        let batch = [];

        // Clear all existing creneaux for this resa ...
        axios.delete(`${baseURL}/creneau-eleve/${currentResa}`)
            .then((response) => {
                if (response.status === 201) { // if request ok
                    console.log("anciens créneauxEleves supprimés")
                    refill(true);
                }
                else { //
                    problemes.push(response.data);
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "CreneauEleve-delete" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {

                problemes.push(error);
                // ----- error management
                setAlertMessage(alertBaseMessage + "CreneauEleve-delete" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })


        function refill(flag) { //function inside insertCreneaux
            console.log(flag)
            ///and refill again
            selectedCreneaux.map((creneau) => { // first we map every selected creneaux ...

                creneau.eleves.map((eleve) => { // ... and map every eleves for each creneau

                    batch.push({ // insert new line in CReneauEleve table ...
                        creneau_id: creneau.creneau.id_creneau, //... with creneau id
                        eleve_id: eleve.id, //...eleve id
                        resa_id: currentResa // and IMPORTANT resa id
                    });

                }); // end of map eleves

            });// end of map selected creenaux

            axios.post(`${baseURL}/creneau-eleve/bulk`, batch)
                .then((response) => {
                    if (response.status === 201) { // insertion ok
                        console.log("tout bon nouveau algo ");
                        console.log(batch);
                        console.log(response.data.data);
                        insertCommentaire();
                    }
                    else { // probleme insertion
                        problemes.push("probleme");
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "CreneauEleve-post" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    problemes.push("probleme");
                    console.log("error l249");
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "CreneauEleve-post" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        } // end of refill

    } // end of insertCreneauxEleves()

    function insertCommentaire() {

        if (comment.length > 0) { // commentaire présent

            axios.post(`${baseURL}/resa-commentaire`, { //fetch create resa
                commentaire: comment,
                by_client: resaInfos.nb_modifs % 2 > 0,
                resa_id: currentResa // and IMPORTANT resa id
            })
                .then((response) => {
                    if (response.status === 201) { // everything went good..
                        // confirmer l'ensemble des requetes
                        confirmSave(true);
                    }
                    else { // if probleme...
                        problemes.push(response.data); //add probleme to list
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "Comment-post" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    //console.error(error);
                    problemes.push(error); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "Comment-post" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        }
        else {
            confirmSave(true);
        }


    }




    function confirmSave(success) { // handle insertions completion => show message for exemple
        if (success === true) {
            console.log("c'est bon on t'a dit");

            navigate("../modifsuccess")
        }
    }


    return (
        <div>

            <Button
                className="bottom-nav-next-confirm"
                onClick={_ => modifResa()}
                variant="contained">
                Envoyez cette proposition <CheckIcon />
            </Button>
            {showAlert === true &&
                <Alert className="bottom-nav-next-confirm-alert" severity="error">{alertMessage}</Alert>
            }
        </div>
    );
}

export default EditValidate;